<template>
  <div class="popup_base">
    <div class="popup" v-click-outside="closePopup">
      <h1>{{ t('確認コードを入力してください') }}</h1>
      <div class="number_area">
        <TextBox
          class="number"
          textClass="one_code"
          maxlength="6"
          inputType="phone"
          placeholder=""
          @handleTextInput="codeChange($event)"
        />
      </div>
      <ErrorMessage
        v-if="errorMessage"
        class="error-message"
        :message="errorMessage"
      />
      <div class="button_area">
        <BlackGradationButton
          class="square-button2"
          :text="t('コードを送信する')"
          :isMaxWidth="true"
          @handleSquareBtnClick="goToSendCode"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import TextBox from '@/components/atoms/TextBox.vue';
import ErrorMessage from '@/components/atoms/ErrorMessage.vue';
import BlackGradationButton from '@/components/atoms/BlackGradationButton.vue';
import t from '@/plugins/i18n';

export default {
  name: 'SMSPopup',
  mixins: [t],

  components: {
    TextBox,
    ErrorMessage,
    BlackGradationButton,
  },

  data: () => ({
    errorMessage: '',
    inputNum: '',
  }),

  props: {
    tel: {
      type: String,
      default: '',
    },
  },

  computed: {
    ...mapGetters({
      sendSMS: 'sms/sendSMS',
      checkSMS: 'sms/checkSMS',
    }),
  },

  watch: {
    sendSMS(newVal) {
      if (newVal.errors && newVal.errors.user_id) {
        alert(newVal.errors.user_id);
        this.closePopup();
      }
    },
    checkSMS(newVal) {
      this.errorMessage = '';
      if (newVal.state === 200) {
        this.$store.dispatch('user/setPointEndResult');
        this.$emit('success');
        return;
      }
      if (newVal.errors.sms_code) {
        this.errorMessage = newVal.errors.sms_code ? newVal.errors.sms_code[0] : '';
      }
    },
  },

  created() {
    const postParams = { tel: this.tel };
    this.$store.dispatch('sms/sendSMS', { postParams });
  },

  methods: {
    codeChange(value) {
      this.inputNum = value;
    },
    goToSendCode() {
      const postParams = { sms_code: this.inputNum };
      this.$store.dispatch('sms/checkSMS', { postParams });
    },
    closePopup() {
      this.$emit('closePopup');
    },
  },
};
</script>

<style lang="scss" scoped>
.popup_base {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 10000;
  display: flex;
  justify-content: center;
  align-items: center;
  .popup {
    background-color: white;
    padding: 60px;
    border-radius: 10px;
    h1 {
      font-size: 24px;
      text-align: center;
      margin-bottom: 30px;
    }
    .number_area {
      display: flex;
      .number {
        width: 300px;
        text-align: center;
        margin: 0 10px;
      }
    }
  }
  .button_area {
    margin-top: 20px;
    display: flex;
    justify-content: center;
    width: 100%;
    height: 40px;
    .square-button2 {
      button {
        padding: 10px 20px;
      }
    }
  }
}
@media screen and  (max-width: $tabletWidth) {
  .popup_base {
    .popup {
      padding: 20px;
      .number_area {
        .number {
          text-align: center;
          margin: 0 5px;
        }
      }
    }
  }
}
</style>
